import { useCallback } from 'react';

import { useEmptyStructure } from 'hooks/useObjectStructure';
import { isDocumentTypeWithLocations, isDocumentTypeWithTransportUnits } from 'services/documentTypes/documentTypes';
import { DocumentType } from 'support/types';
import { ColumnTypesInternal } from 'support/types/webediTable';
import { useDataTableContext } from 'components/DataTable/contexts/DataTableContext';

export const useAppendLineItem = (documentType: DocumentType, packingListEnabled = false) => {
  const { fields, append } = useDataTableContext();
  const emptyLineItem = useEmptyStructure(fields);

  const appendLineItem = useCallback(() => {
    let internalFields: Record<string, string | boolean> = {
      [ColumnTypesInternal.procuros_added]: true,
    };

    if (isDocumentTypeWithTransportUnits(documentType)) {
      // With the packing list enabled, placement happens exclusively in the modal, so a new item
      // starts unplaced (empty ref) rather than attached to the default (SSCC-less) first unit.
      internalFields = {
        ...internalFields,
        parent_transport_unit: packingListEnabled ? '' : "$['transport_units'][0]",
      };
    } else if (isDocumentTypeWithLocations(documentType)) {
      internalFields = {
        ...internalFields,
        parent_location: "$['locations'][0]",
      };
    }

    append({
      ...emptyLineItem,
      _internal: internalFields,
    });

    setTimeout(() => {
      const table = document.getElementById('line_items');
      table?.scrollTo({ top: table.scrollHeight });
    }, 1000);
  }, [documentType, packingListEnabled, emptyLineItem, append]);

  return appendLineItem;
};
